<template>
    <div class="rounded-lg" style="z-index: 200; min-height: 500px;">
        <block v-if="loading"></block>
        <v-stepper v-model="step" class="white pa-4">
            <v-stepper-header style="flex-wrap: nowrap;">
                <v-stepper-step :complete="step > 1" step="1">
                    Carga de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 2" step="2">
                    Verificación de datos
                </v-stepper-step>
                <v-stepper-step :complete="step > 3" step="3">
                    Previsualización de datos
                </v-stepper-step>
                <v-stepper-step step="4">
                    Procesamiento de datos
                </v-stepper-step>
            </v-stepper-header>

            <div style="margin-top: 1rem; display: flex; flex-direction: row; justify-content: flex-end;">
                <!-- <v-btn class="btn-save" @click="downloadTemplate" :disabled="loading">
                    <v-icon class="mr-2">mdi-download</v-icon>Descargar plantilla para importar
                </v-btn> -->
                <v-btn class="btnclean" @click="resetAll" :disabled="loading">
                    <v-icon class="mr-2">mdi-broom</v-icon>Reiniciar
                </v-btn>
            </div>
            
            <v-stepper-items>
                
                <!-- Step 1: Upload Json -->
                <v-stepper-content step="1">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">                                
                                <v-card-title class="font-weight-bold text-nowrap">Importar servicios desde archivos JSON</v-card-title>
                                <v-card-actions>
                                    <v-row style="margin-top: 1rem;">
                                        <v-col cols="12" md="6" xs="12">
                                            <div style="margin-bottom: 2rem;">
                                                <input
                                                    id="file-input"
                                                    style="display: none;"
                                                    type="file"
                                                    webkitdirectory
                                                    directory
                                                    multiple
                                                    @click="$event.target.value=''"
                                                    @change="handleFolderFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center;">
                                                    Elegir directorio completo
                                                </label>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <div style="margin-bottom: 2rem;">    
                                                <input
                                                    id="file-input-individual"
                                                    style="display: none;"
                                                    type="file"
                                                    multiple
                                                    accept=".json"
                                                    @click="$event.target.value=''"
                                                    @change="handleIndividualFiles($event)"
                                                    :disabled="loading || dataLoaded"
                                                />
                                                <label for="file-input-individual" style="cursor: pointer; width: 100%; border: 1px solid grey; height: 40px; border-radius: 5px; display: flex; align-items: center; justify-content: center; ">
                                                    Elegir varios archivos individualmente
                                                </label>
                                            </div>
                                        </v-col>
                                        
                                        <v-col cols="12">
                                            <div v-if="selectedFilesNames.length > 0" style="margin: 1rem 0;">
                                                <h4>Archivos seleccionados:</h4>
                                                <v-data-table 
                                                    :headers="[{text: '', value: 'name'}]" 
                                                    :items="selectedFilesNames"
                                                    :items-per-page="5"
                                                    :footer-props="{
                                                        showFirstLastPage: false,                                         
                                                        'items-per-page-options': [],
                                                        'items-per-page-text':'Items por pagina:',
                                                    }"
                                                    class="file-table"
                                                >
                                                </v-data-table>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                                <v-card-actions style="padding: 1rem; justify-content: flex-end;">
                                    <v-btn v-if="!dataLoaded" class="btn-import" @click="duplicatedValidation" :disabled="loading">
                                        <v-icon class="mr-2">mdi-folder-upload</v-icon>Cargar archivos y continuar
                                    </v-btn>
                                    <v-btn v-else class="btncontinue" @click="nextStep" :disabled="loading">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                
                <!-- Step 2: Verifying data -->
                <v-stepper-content step="2">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Datos de los archivos cargados</v-card-title>
                                <v-card-text v-if="errors" style="display: flex; flex-direction: row;">
                                    <v-icon color="red darken-4" style="margin: 10px; font-size: 20px;" >mdi-alert-circle</v-icon>
                                    <p style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        Algunos servicios no se encuentran registrados y serán creados automáticamente.
                                    </p>
                                </v-card-text>

                                <v-data-table 
                                    :headers="headers" 
                                    :items="data"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError(item.error.message)">mdi-alert-circle</v-icon>
                                        <v-icon v-else style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                    <template v-slot:item.toEntry="{ item }">
                                        <v-checkbox class="check" v-model="item.toEntry" @click.prevent="switchEntryData(item)"></v-checkbox>
                                        <!-- <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon> -->
                                    </template>
                                    <template v-slot:item.delete="{ item }">
                                        <v-icon style="margin: 10px; font-size: 20px;" @click.prevent="deleteFile(item)">mdi-delete</v-icon>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="nextStep">Continuar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>

                <!-- Step 3: Preview Data -->
                <v-stepper-content step="3">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Servicios importados de los archivos seleccionados</v-card-title>
                                <v-card-title class="font-weight-bold text-nowrap">
                                    <!-- TODO agregado temporalmente -->
                                    Fecha para correlativo de facturas
                                    <date-picker
                                        @dateSelected="
                                            (val) => {
                                            FechaIdInvoice = val;
                                            }
                                        "
                                        v-model="FechaIdInvoice"
                                        :value="FechaIdInvoice"
                                        />
                                </v-card-title>

                                <AccountingAssign
                                    v-if="$store.getters['rolesUser/getCustomRole'](179)"
                                    v-model="account.id_account"
                                    :assignAll="true"
                                    @accountChanged="accountChanged"
                                    @assignAllAccounts="assignAllAccounts"
                                >
                                </AccountingAssign>
                                
                                <v-data-table 
                                    :headers="expensesHeaders" 
                                    :items="expensesData"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.accountSearchButton="{ item, index }">
                                        <span class="">
                                            <a @click="chooseAccount( index )">
                                                <v-icon>mdi-magnify</v-icon>
                                            </a>
                                        </span>
                                    </template>
                                    <template v-slot:item.service_status="{ item }">
                                        <v-chip 
                                            :color="item.service_exists ? 'green' : 'blue'" 
                                            text-color="white" 
                                            small
                                        >
                                            {{ item.service_exists ? 'Existe' : 'Creado' }}
                                        </v-chip>
                                    </template>
                                    <template v-slot:item.ItemDeclarationType="{ item, index }">
                                        <span class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.ItemDeclarationType"
                                                @change="e => data[ index ].ItemDeclarationType = e.target.value"
                                            >
                                                <option v-for="tipoItem in tipoItemCompraGasto" :value="tipoItem.Codigo" :key="tipoItem.Codigo">
                                                    {{ tipoItem.Valores }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                    <template v-slot:item.account_code="{ item, index }">
                                        <span
                                            v-if="!isSelectShowed"
                                            @click="toggleSelect(index)"
                                            >
                                            {{ item.account_code ?? 'Seleccionar cuenta' }}
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                        <span v-else class="scroll-fixing-purchase">
                                            <select
                                                style="width: calc(100% - 30px); padding: 5px"
                                                class="form-control custom-select"
                                                v-model="item.id_account"
                                                @change="(e) => handleChangeAccount(e, index)"
                                                @blur="handleBlurOnSelect"
                                                :ref="`accountListSelect-${index}`"
                                            >
                                                <option v-for="accountItem in accountList" :value="accountItem.id_account" :key="accountItem.id_account">
                                                    {{ accountItem.account_description }}
                                                </option>
                                            </select>
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </span>
                                    </template>
                                </v-data-table>
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep">Anterior</v-btn>
                                    <v-btn class="btnoption" @click="onClickProcess">Procesar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
        
                <!-- Step 4: Process Data -->
                <v-stepper-content step="4">
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="loading" class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Procesando la información importada</v-card-title>
                                <!-- <v-card-text style="padding: 0 16px;">
                                    <v-progress-linear
                                        v-if="loading"
                                        indeterminate
                                        color="primary"
                                        class="my-4"
                                    ></v-progress-linear>
                                </v-card-text>
                                <div style="height: 50px;"></div> -->
                            </v-card>
                            <v-card v-else class="card-step">
                                <v-card-title class="font-weight-bold text-nowrap">Estado del procesamiento de datos</v-card-title>

                                <v-card-text v-if="!processError && processed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Se han procesado un total de {{ processed.length }} facturas de servicios generadas desde los archivos seleccionados.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showProcessed=!showProcessed" style="min-width: 100px;">
                                            {{!showProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('SUCCESS')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table 
                                    v-if="showProcessed"
                                    :headers="processHeaders" 
                                    :items="processed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Items por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{}">
                                        <v-icon style="margin: 10px; font-size: 20px;">mdi-check-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="!processError && notProcessed.length">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px; color: #e3191e !important;">
                                        No se logro procesar un total de {{ notProcessed.length }} facturas de servicios, debido a la existencia de errores en la información o servicios no válidos.
                                    </h3>
                                    <v-card-actions style="padding: 0px; gap: 50px;">
                                        <v-btn class="btnoption" @click="showNotProcessed=!showNotProcessed" style="min-width: 100px;">
                                            {{!showNotProcessed ? 'Ver' : 'Ocultar'}}
                                            <v-icon v-if="!showNotProcessed" style="margin-left: 5px;">mdi-menu-down</v-icon>
                                            <v-icon v-else style="margin-left: 5px;">mdi-menu-up</v-icon>
                                        </v-btn>
                                        <!-- <v-btn class="btnoption" @click="exportToExcel('ERROR')" style="background-color: #00a178 !important;">
                                            <v-icon>mdi-file-excel</v-icon>
                                        </v-btn> -->
                                    </v-card-actions>
                                </v-card-text>
                                <v-data-table 
                                    v-if="showNotProcessed"
                                    :headers="processHeaders" 
                                    :items="notProcessed"
                                    :items-per-page="50"
                                    :footer-props="{
                                        showFirstLastPage: true,
                                        firstIcon: 'mdi-page-first',
                                        lastIcon: 'mdi-page-last',                                            
                                        'items-per-page-options': [50, 100, 250],
                                        'items-per-page-text':'Productos por pagina:',
                                    }"
                                    class="data-table"
                                >
                                    <template v-slot:item.status="{ item }">
                                        <v-icon v-if="item.error?.provider" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError('Ha ocurrido un error al insertar el proveedor de esta factura de gastos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else-if="item.error?.isDuplicated" color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError('Esta factura de gastos ya se encuentra registrada en la base de datos.')">mdi-alert-circle</v-icon>
                                        <v-icon v-else color="red darken-4" style="margin: 10px; font-size: 20px;" @click.prevent="showError('Ha ocurrido un error al insertar la factura de gastos de este archivo JSON.')">mdi-alert-circle</v-icon>
                                    </template>
                                </v-data-table>

                                <v-card-text v-if="processError" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        Ha ocurrido un error en el procesamiento, vuelva a intentarlo más tarde. 
                                    </h3> 
                                </v-card-text>

                                <v-card-text v-if="!expensesData.length" style="display: flex; flex-direction: row;">
                                    <h3 style="margin-top: 20px; margin-bottom: 20px; font-size: 16px;">
                                        No existen productos pendiente de procesamiento. 
                                    </h3> 
                                </v-card-text>
                                
                                <v-card-actions style="padding: 1rem; justify-content: space-between;">
                                    <v-btn class="btncontinue" @click="prevStep" :disabled="expensesData.length > 0 || expensesData.length > 0">Anterior</v-btn>
                                    <v-btn class="btncontinue" @click="resetAll">Volver al inicio</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-stepper-content>
                    
            </v-stepper-items>
        </v-stepper>
        <alerts
            v-if="alert.show"
            v-on:close_alert="closeAlert"
            v-on:accept_alert="acceptAlert"
            :properties="alert"
        >
        </alerts>
        <v-dialog v-model="showModal" :width="dialogWidth">
            <v-card>
                <AccountingItemForm
                    :win="win"
                    v-on:sendSelection="accountSelectionHandler"
                    v-on:closeDialog="showModal = false"
                />
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";
import AccountingAssign from "./AccountingAssign.vue";
import * as XLSX from "xlsx";
import { mapGetters } from "vuex";
import AccountingItemForm from "./AccountingItemForm.vue";
import DatePicker from "../../../components/DatePicker.vue";
import { parseJsonRelaxedCanonical } from "@/helpers/parseJson";
export default {
    name: "ServiceInvoiceManagmentMassiveEntry",
    props: ["win"],
    components: {
        Block,
        Alerts,
        AccountingAssign,
        AccountingItemForm,
        DatePicker
    },
    data() {
        return {
            step: 1,
            loading: false,
            dataLoaded: false,
            selectAll: true,
            percentageIvaCheck: true,
            percentageIva: 100,
            id_bussiness: null,
            bussiness: null,
            id_branch: null,
            id_user: null,

            selectedFiles: [],
            selectedFilesNames: [],
            currentJson: null,
            dataFiles: [],
            headerFiles: [],
            data: [],
            headers: [],
            expensesData: [],
            expensesHeaders: [],
            processHeaders: [],

            accountList: [],
            isSelectShowed: false,
            account: {
                id_account: null
            },

            errors: null,
            processError: false,

            processed: [],
            notProcessed: [],
            showNotProcessed: false,
            showProcessed: false,
           
            invoiceType: [null, "FCF", "CCF", "DNC", "FNS", "FEX", "DCL"],
            paymentMethod: [ "Efectivo", "Cheque", "Transferencia", "Tarjeta de Crédito", "Otro" ],
            invoiceStatus: ["Pendiente de pago", "Cancelada", "Crédito", "Anulada"],
            days: ['8 Dias', '15 Dias', '30 Dias', '90 Dias', '120 Dias', '180 Dias'],

            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            CustomCSVPeriodFlag: false,
            CustomCSVPeriodYear: null,
            CustomCSVPeriodMonth: null,
            ClasificationRent: '2',
            submitCustomCSVPeriodState: false,
            cleanState: false,
            targetIndex: null,
            showModal: false,
            FechaIdInvoice: null,
        };
    },
    async mounted() {
        this.id_bussiness = JSON.parse(localStorage.getItem("user")).businessid;
        this.business = JSON.parse(localStorage.getItem("user")).business;
        this.id_branch = JSON.parse(localStorage.getItem("user")).branch;
        this.id_user = JSON.parse(localStorage.getItem("user")).id;
        await this.getAllAccounts();
        
        this.headers = [
            {text: '' , value: 'toEntry'},
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Cliente' , value: 'customer'},
            {text: 'NIT Cliente' , value: 'nit'},
            {text: 'NRC Cliente' , value: 'nrc'},
            {text: 'Nombre Cliente' , value: 'nombre'},
            {text: 'Nombre Comercial Cliente' , value: 'nombreComercial'},
            
            {text: 'ivaRete1' , value: 'ivaRete1'},
            {text: 'ivaPerci1' , value: 'ivaPerci1'},
            {text: 'totalIva' , value: 'totalIva'},
            {text: 'reteRenta' , value: 'reteRenta'},
            {text: 'descuNoSuj' , value: 'descuNoSuj'},
            {text: 'descuExenta' , value: 'descuExenta'},
            {text: 'descuGravada' , value: 'descuGravada'},
            {text: 'porcentajeDescuento' , value: 'porcentajeDescuento'},
            {text: 'totalDescu' , value: 'totalDescu'},
            {text: 'totalNoSuj' , value: 'totalNoSuj'},
            {text: 'totalExenta' , value: 'totalExenta'},
            {text: 'totalGravada' , value: 'totalGravada'},
            {text: 'totalNoGravado' , value: 'totalNoGravado'},
            {text: 'subTotalVentas' , value: 'subTotalVentas'},

            {text: 'Total Operación' , value: 'montoTotalOperacion'},
            {text: 'Total a Pagar' , value: 'totalPagar'},
            {text: '' , value: 'delete'},
        ];
        this.expensesHeaders = [
            {text: '' , value: 'accountSearchButton'},
            {text: 'Código' , value: 'account_code'},
            {text: 'Cuenta' , value: 'account_name'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número control' , value: 'numeroControl'},
            {text: 'Codigo generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'Cliente' , value: 'customer'},
            {text: 'Nombre del servicio' , value: 'descripcion'},
            {text: 'Código' , value: 'codigo'},
            {text: 'Estado del servicio' , value: 'service_status'},
            {text: 'Precio' , value: 'precioUni'},
            {text: 'Cantidad' , value: 'cantidad'},
            {text: 'Estado' , value: 'condicionOperacion'},
            {text: 'Servicio declarable como:' , value: 'ItemDeclarationType'},
            {text: 'Descuento' , value: 'montoDescu'},
            {text: 'Total no sujeto' , value: 'ventaNoSuj'},
            {text: 'Total exento' , value: 'ventaExenta'},
            {text: 'Total gravado' , value: 'ventaGravada'},
            {text: 'Total a pagar' , value: 'totalPagar'},
            {text: 'Cuenta Contable' , value: 'account_code'},
        ];

        this.processHeaders = [
            {text: 'Estado' , value: 'status'},
            {text: 'Fecha' , value: 'fecEmi'},
            {text: 'Número Control' , value: 'numeroControl'},
            {text: 'Codigo Generación' , value: 'codigoGeneracion'},
            {text: 'Tipo de factura' , value: 'invoiceType'},
            {text: 'ID Cliente' , value: 'customer'},
            {text: 'NIT Cliente' , value: 'nit'},
            {text: 'NRC Cliente' , value: 'nrc'},
            {text: 'Nombre Cliente' , value: 'nombre'},
            {text: 'Nombre Comercial Cliente' , value: 'nombreComercial'},
            {text: 'Sub Total' , value: 'subTotal'},
            {text: 'Total Operación' , value: 'montoTotalOperacion'},
            {text: 'Total a Pagar' , value: 'totalPagar'},
        ];
    },
    watch: {
        /* tableData: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                this.errors = newValue.some((item) => item.error);
            }
        }, */
        selectedFiles: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    this.selectedFilesNames.push({name: item.name});
                }
            }
        },
        data: {
            deep: true,
            inmediate: true,
            handler(newValue) {
                for (const item of newValue) {
                    if(item.toEntry == false) {
                        this.selectAll = false;
                    }
                }
            }
        },
        
    },
    computed: {
        ...mapGetters(["getCatalogMH"]),
        dialogWidth() {
            return this.$vuetify.breakpoint.smAndDown ? "95%" : "60%";
        },
        tipoItemCompraGasto() {
            return this.getCatalogMH("TipoItemCompraGasto");
        },
    },
    methods: {
        chooseAccount(index) {
            this.showModal =true
            this.targetIndex = index;
        },
        accountSelectionHandler(data) {
            this.showModal = false;
            const { id_account, account_code, account_description } = data;

            this.$set(this.expensesData[ this.targetIndex ], 'id_account', id_account);
            this.$set(this.expensesData[ this.targetIndex ], 'account_code', account_code);
            this.$set(this.expensesData[ this.targetIndex ], 'account_name', account_description);
            this.data[ this.targetIndex ].id_account = id_account;
            this.data[ this.targetIndex ].account_code = account_code;
            this.data[ this.targetIndex ].account_name = account_description;
        },
        accountChanged( e ) {
            this.account.id_account = e
        },
        setCustomCSVPeriod(val){
            this.CustomCSVPeriodFlag = val
        },
        setCustomCSVPeriodYear(val){
            this.CustomCSVPeriodYear = val
        },
        setCustomCSVPeriodMonth(val){
            this.CustomCSVPeriodMonth = val
        },
        nextStep() {
            if(this.step === 1) {
                if(this.selectedFiles.length && !this.dataLoaded) {
                    this.showAlert("warning", "Advertencia", "Antes de continuar debe cargar los archivos seleccionados.");
                    return;
                }
            }
            if(this.step == 2) {
                let errors = 0;

                if( this.CustomCSVPeriodFlag ) {
                    this.submitCustomCSVPeriodState = true;
                    !this.CustomCSVPeriodMonth && ( errors += 1 );
                    !this.CustomCSVPeriodYear && ( errors += 1 );
                }

                if (errors > 0) {
                    this.showAlert(
                        "warning",
                        "Advertencia",
                        "Debe llenar todos los campos obligatorios"
                    );
                    return;
                }

                this.handleExpensesDetails();
            }
            this.step++;
        },
        prevStep() {
            this.step--;
        },

        handleFolderFiles(event) {
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON en el directorio seleccionado.');
            }
        },
        handleIndividualFiles(event) {
            //console.log('----here----', event);
            this.resetData();
            const files = Array.from(event.target.files);
            const jsonFiles = files.filter(file => file.name.endsWith('.json') || file.name.endsWith('.JSON'));

            if (jsonFiles.length > 0) {
                this.selectedFiles = [...this.selectedFiles, ...jsonFiles];
            } else {
                alert('No se encontraron archivos JSON seleccionados.');
            }
        },
        async handleFilesUpload() {
            if (!this.selectedFiles.length) {
                this.showAlert("warning", "Advertencia", "Debe seleccionar los archivos a cargar.");
                return;
            }
            this.loading = true;
            try {
                const generatedCodes = await this.dataFiles.map(item => item.identificacion.codigoGeneracion);
                const checkDuplicatedResponse = await this.checkDuplicatedEntries(generatedCodes);
                for (const item of this.dataFiles) {                    
                    this.currentJson = item.identificacion.codigoGeneracion;                    
                    item.toEntry = true;
                    
                    // Detectar si es la nueva versión
                    const isNewVersion = this.isNewVersionJson(item);
                    
                    const customer = await this.checkCustomer(item);
                    if(!customer){
                        //console.log('Not checked');
                        // Para nueva versión, usar datos de cuerpoDocumento.ivaPercibido en lugar de resumen.ivaPerci1
                        const ivaPerci1Value = isNewVersion ? item.cuerpoDocumento.ivaPercibido : item.resumen?.ivaPerci1;
                        const newCustomer = await this.addCustomer({ dte: item , ivaPerci1: ivaPerci1Value });
                        if(newCustomer && newCustomer.ID_Customer) {
                            item.customer = newCustomer.ID_Customer;
                            item.id_account = newCustomer.id_sales_account ? newCustomer.id_sales_account : null;
                            //this.customers = await this.getAllCustomers();
                        }
                        else {
                            item.error = {
                                customerError: true,
                                message: 'No se pudo insertar el cliente de esta factura, intentelo nuevamente más tarde.',
                            };
                            item.toEntry = false;
                        }
                    }
                    else {
                        //console.log('Customer checked', customer);
                        item.customer = customer.ID_Customer;
                        item.id_account = customer.id_sales_account ? customer.id_sales_account : null;
                        item.account_code = customer.id_sales_account ? this.accountList.find(i => i.id_account == customer.id_sales_account)?.account_code : null;
                        item.account_description = customer.id_sales_account ? this.accountList.find(i => i.id_account == customer.id_sales_account)?.account_description : null;
                    }

                    
                    if(checkDuplicatedResponse.includes(item.identificacion.codigoGeneracion)) {
                        item.error = {
                            isDuplicated: true,
                            message: item.error?.message ? item.error?.message : 'Esta factura ya se encuentra registrada, si desea sobreescribir la información existente debera seleccionar el checkbox.'
                        };
                        item.toEntry = false;
                    }

                    if(item.identificacion.tipoDte == "03") item.invoiceType = "CCF";
                    if(item.identificacion.tipoDte == "05") item.invoiceType = "DNC";
                    if(item.identificacion.tipoDte == "11") item.invoiceType = "FEX";
                    if(item.identificacion.tipoDte == "14") item.invoiceType = "FNS";
                    //if(item.identificacion.tipoDte == "15") item.invoiceType = "CDD";
                    if(item.identificacion.tipoDte == "01") item.invoiceType = "FCF";
                    if(item.identificacion.tipoDte == "09") item.invoiceType = "DCL";

                    let tributos = {
                        iva: 0,
                    };

                    // Detectar si es la nueva versión
                    const isNewVersionFormat = this.isNewVersionJson(item);

                    if (!isNewVersionFormat && item.resumen && item.resumen.tributos && item.resumen.tributos.length) {
                        // Versión original - procesar tributos desde resumen
                        let index = 11;
                        for (const el of item.resumen.tributos) {
                            if(el.codigo == '20' || el.descripcion.includes('IVA')){
                                tributos.iva = el.valor;
                                if((this.headers.some(i => i.value == 'iva')) !== true) {
                                    this.headers.splice(index, 0, {text: 'IVA' , value: 'iva'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'D1' || el.descripcion.includes('FOVIAL')){
                                tributos.fovial = el.valor;
                                if((this.headers.some(i => i.value == 'fovial')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Fovial' , value: 'fovial'});
                                    index += 1;
                                }
                            }
                            else if(el.codigo == 'C8' || el.descripcion.includes('COTRANS')){
                                tributos.cotrans = el.valor;
                                if((this.headers.some(i => i.value == 'cotrans')) !== true) {
                                    this.headers.splice(index, 0, {text: 'Cotrans' , value: 'cotrans'});
                                    index += 1;
                                }
                            }
                            else {
                                tributos[el.descripcion] = el.valor;
                                if((this.headers.some(i => i.value == el.descripcion)) !== true) {
                                    this.headers.splice(index, 0, {text: el.descripcion , value: el.descripcion});
                                    index += 1;
                                }
                            }
                        }
                    } else if (isNewVersionFormat && item.cuerpoDocumento) {
                        // Nueva versión - extraer IVA desde cuerpoDocumento
                        tributos.iva = item.cuerpoDocumento.iva || 0;
                        if(tributos.iva > 0 && (this.headers.some(i => i.value == 'iva')) !== true) {
                            this.headers.splice(11, 0, {text: 'IVA' , value: 'iva'});
                        }
                    }

                    if(item.invoiceType == "FEX" && !isNewVersionFormat && item.resumen) {
                        item.flete = item.resumen.flete;       
                        item.seguro = item.resumen.seguro;       
                    }

                    let rowData;
                    
                    if (isNewVersionFormat) {
                        // Nueva versión - usar datos de cuerpoDocumento
                        rowData = {
                            ...item,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            totalIva: item.cuerpoDocumento.iva || 0,
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            descuExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            descuGravada: 0, // No esta en la version nueva creada para mantener el formato original
                            porcentajeDescuento: 0, // No esta en la version nueva creada para mantener el formato original
                            totalDescu: 0, // No esta en la version nueva creada para mantener el formato original
                            totalNoSuj: 0, // No esta en la version nueva creada para mantener el formato original
                            totalExenta: 0, // No esta en la version nueva creada para mantener el formato original
                            totalGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            totalNoGravado: 0, // No esta en la version nueva creada para mantener el formato original
                            subTotalVentas: item.cuerpoDocumento.subTotal || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            customer: item.customer,
                            nit: item.receptor.nit,
                            nrc: item.receptor.nrc,
                            nombre: item.receptor.nombre,
                            nombreComercial: item.receptor.nombreComercial,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            ItemDeclarationType: 2,
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: (item.responseMH && item.responseMH.selloRecibido) ? item.responseMH.selloRecibido : (item.sello || null),
                        };
                    } else {
                        // Versión original
                        const totalPagar = item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        rowData = {
                            ...item,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            totalIva: item.resumen?.totalIva || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            descuNoSuj: item.resumen?.descuNoSuj || 0,
                            descuExenta: item.resumen?.descuExenta || 0,
                            descuGravada: item.resumen?.descuGravada || 0,
                            porcentajeDescuento: item.resumen?.porcentajeDescuento || 0,
                            totalDescu: item.resumen?.totalDescu || 0,
                            totalNoSuj: item.resumen?.totalNoSuj || 0,
                            totalExenta: item.resumen?.totalExenta || 0,
                            totalGravada: item.resumen?.totalGravada || 0,
                            totalNoGravado: item.resumen?.totalNoGravado || 0,
                            subTotalVentas: item.resumen?.subTotalVentas || 0,
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            invoiceType: item.invoiceType,
                            customer: item.customer,
                            nit: item.receptor.nit,
                            nrc: item.receptor.nrc,
                            nombre: item.receptor.nombre,
                            nombreComercial: item.receptor.nombreComercial,
                            subTotal: item.resumen?.subTotal || 0,
                            montoTotalOperacion: item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            toEntry: item.toEntry,
                            error: item.error || null,
                            dteJson: item,
                            ItemDeclarationType: 2,
                        };
                    }
                    
                    for (const prop in tributos) {
                        rowData = {
                            ...rowData,
                            [prop]: tributos[prop]
                        }
                    }
                    
                    this.data.push(rowData);
                }
                setTimeout(() => {
                    this.loading = false;
                    this.dataLoaded = true;
                    this.currentJson = null; 
                    //console.log(this.data);          
                    this.showAlert("success", "Exito", "Los archivos seleccionados fueron cargados correctamente.", "continueStep");
                }, 1000);
            } 
            catch (error) {                
                console.log(this.selectedFilesNames);
                
                const fileName = this.selectedFilesNames.find(item => item.name.includes(this.currentJson));
                console.log(error.message);
                this.loading = false;
                if(fileName && fileName.name) {
                    this.showAlert("warning", "Advertencia", `Ha ocurrido un error al cargar el archivo ${fileName.name}, revise la estructura del JSON.`);
                }
                else {
                    this.showAlert("warning", "Advertencia", "Ha ocurrido un error al cargar los archivos, vuelva a intentarlo más tarde.");
                }
                this.currentJson = null; 
            }
        },
        async duplicatedValidation() {
            this.loading = true;
            let isDuplicatedFiles = false
            let invalidJsonFiles = []
            // Procesar los archivos JSON seleccionados
            for (const file of this.selectedFiles) {
                if (file.type === "application/json") {
                    try {
                        const content = await this.readFile(file);
                        const jsonContent = parseJsonRelaxedCanonical(content);
                        const isInDataFiles = this.dataFiles.some(item => item.identificacion.codigoGeneracion === jsonContent.identificacion.codigoGeneracion);
                        jsonContent['fileName'] = file.name;
                        if (!isInDataFiles) {
                            this.dataFiles.push(jsonContent);
                        } else {
                            isDuplicatedFiles = true
                        }
                    } catch (error) {
                        console.error(`Error parsing JSON file ${file.name}:`, error);
                        invalidJsonFiles.push({
                            fileName: file.name,
                            error: error.message
                        });
                    }
                }
            }
            
            // Manejar archivos JSON inválidos
            if (invalidJsonFiles.length > 0) {
                const errorDetails = invalidJsonFiles.map(item => `${item.fileName}: ${item.error}`).join('\n');
                this.showAlert("warning", "Error de formato JSON", 
                    `Los siguientes archivos tienen errores de formato JSON y no pueden ser procesados:\n\n${errorDetails}\n\nPor favor, corrija estos archivos antes de continuar.`);
                this.loading = false;
                return;
            }
            
            if (isDuplicatedFiles) {
                this.showAlert("question2", "Advertencia", "Algunos archivos están duplicados por lo que se omitirán. Desea continuar?", "structureValidation");
                this.loading = false;
            } else {
                this.structureValidation();
            }

        },
        structureValidation() {
            console.log('structureValidation');
            
            const invalidJsonFiles = this.dataFiles.filter(file => !this.jsonValidation(file));
            this.dataFiles = this.dataFiles.filter(file => this.jsonValidation(file));
            const invalidFilesNames = invalidJsonFiles.map(file => file.fileName);
            if (invalidJsonFiles.length >= this.dataFiles.length) {
                this.showAlert("warning", "Advertencia", "Ninguno de los archivos tiene la estructura correcta, por favor revise la estructura de los archivos JSON.");
                this.loading = false;
                return;
            } 
            if (invalidJsonFiles.length > 0) {
                this.showAlert("question2", "Advertencia", `Los archivos ${invalidFilesNames.join(", ")} no tienen la estructura correcta y se omitiran. Desea continuar?`, "handleFilesUpload");
                this.loading = false;
            } else {
                this.handleFilesUpload();
            }
        },
        jsonValidation(json) {
            if (!json) return false;

            // Detectar si es la nueva versión del JSON (DCL - Declaración de Comisiones por Liquidación)
            const isNewVersion = this.isNewVersionJson(json);

            if (isNewVersion) {
                // Validación para la nueva versión
                const newVersionAttributes = [
                    'emisor',
                    'receptor', 
                    'identificacion',
                    'cuerpoDocumento',
                    'extension'
                    // responseMH es opcional en la nueva versión
                ];

                for (const key of newVersionAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal para nueva versión: ${key}`);
                        return false;
                    }
                }
            } else {
                // Validación para la versión original
                const principalAttributes = [
                    'emisor',
                    //'donante',
                    'receptor',
                    'resumen',
                    'identificacion',
                    'cuerpoDocumento'
                ];

                for (const key of principalAttributes) {
                    if (!Object.prototype.hasOwnProperty.call(json, key)) {
                        console.error(`Falta el atributo principal: ${key}`);
                        return false;
                    }
                }
            }

            return true;
        },
        isNewVersionJson(json) {
            // Detecta si es la nueva versión basándose en:
            // 1. Presencia de 'extension' 
            // 2. tipoDte "09" (DCL)
            // 3. cuerpoDocumento como objeto (no array)
            return json.extension && 
                   json.identificacion?.tipoDte === "09" && 
                   json.cuerpoDocumento && 
                   !Array.isArray(json.cuerpoDocumento);
        },
        async handleExpensesDetails() {
            this.loading = true;
            const services = [];
            for (const item of this.dataFiles) {                                                
                if(item.toEntry === true && !item.error?.customerError) {
                    
                    // Detectar si es la nueva versión
                    const isNewVersion = this.isNewVersionJson(item);
                    
                    if (isNewVersion) {
                        // Nueva versión - cuerpoDocumento es un objeto
                        const headerExpense = {
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            documentType: 2,
                            invoiceType: item.invoiceType,
                            customer: item.customer,
                            subTotal: item.cuerpoDocumento.subTotal || 0,
                            montoTotalOperacion: item.cuerpoDocumento.valorOperaciones || 0,
                            totalPagar: item.cuerpoDocumento.liquidoApagar || 0,
                            totalLetras: item.cuerpoDocumento.totalLetras || '',
                            ivaPerci1: item.cuerpoDocumento.ivaPercibido || 0,
                            ivaRete1: 0, // No esta en la version nueva creada para mantener el formato original
                            reteRenta: 0, // No esta en la version nueva creada para mantener el formato original
                            condicionOperacion: 'Cancelada', // Valor por defecto para nueva versión
                            id_account: item.id_account,
                            account_code: item.account_code,
                            account_name: item.account_description,
                        };
                        
                        // Para la nueva versión, crear un solo servicio con toda la información
                        const serviceName = `${item.receptor.nombre}`.trim(); // Normalizar espacios
                        const alternateCode = null; // Para DCL no hay código específico
                        
                        // Verificar si el servicio existe
                        let existingService = await this.checkServiceExists(serviceName, alternateCode);
                        let serviceId = null;
                        
                        if (!existingService) {
                            // Crear el servicio si no existe
                            const newServiceData = {
                                descripcion: serviceName,
                                codigo: alternateCode,
                                precioUni: item.cuerpoDocumento.liquidoApagar || 0
                            };
                            existingService = await this.createService(newServiceData);
                        }
                        
                        serviceId = existingService ? existingService.CodeService : null;
                        
                        const serviceExists = existingService && (existingService.exists === true || !existingService.created);

                        const service = {
                            ...headerExpense,
                            descripcion: serviceName,
                            codigo: alternateCode,
                            precioUni: item.cuerpoDocumento.liquidoApagar || 0,
                            cantidad: 1,
                            montoDescu: 0,
                            ventaNoSuj: 0,
                            ventaExenta: 0,
                            ventaGravada: item.cuerpoDocumento.valorOperaciones || 0,
                            total: item.cuerpoDocumento.liquidoApagar || 0,
                            ItemDeclarationType: 2,
                            id_service: serviceId,
                            service_exists: serviceExists,
                            service_status: serviceExists ? 'Existe' : 'Creado',
                            // Campos específicos de la nueva versión
                            comision: item.cuerpoDocumento.comision || 0,
                            ivaComision: item.cuerpoDocumento.ivaComision || 0,
                            montoSujetoPercepcion: item.cuerpoDocumento.montoSujetoPercepcion || 0,
                            montoSinPercepcion: item.cuerpoDocumento.montoSinPercepcion || 0,
                            empleadoEntrega: item.extension ? item.extension.nombEntrega : null,
                            codigoEmpleado: item.extension ? item.extension.codEmpleado : null,
                            selloRecibido: (item.responseMH && item.responseMH.selloRecibido) ? item.responseMH.selloRecibido : (item.sello || null),
                        };

                        services.push(service);
                        
                    } else {
                        // Versión original - cuerpoDocumento es un array
                        const totalPagar = item.resumen?.totalPagar || item.resumen?.montoTotalOperacion || 0;
                        const headerExpense = {
                            fecEmi: this.formatDate(item.identificacion.fecEmi),
                            numeroControl: item.identificacion.numeroControl,
                            codigoGeneracion: item.identificacion.codigoGeneracion,
                            documentType: 2,
                            invoiceType: item.invoiceType,
                            customer: item.customer,
                            subTotal: item.resumen?.subTotal || 0,
                            montoTotalOperacion: item.resumen?.montoTotalOperacion || 0,
                            totalPagar: totalPagar,
                            totalLetras: item.resumen?.totalLetras || '',
                            ivaPerci1: item.resumen?.ivaPerci1 || 0,
                            ivaRete1: item.resumen?.ivaRete1 || 0,
                            reteRenta: item.resumen?.reteRenta || 0,
                            condicionOperacion: this.invoiceStatus[item.resumen?.condicionOperacion] || 'Pendiente de pago',
                            id_account: item.id_account,
                            account_code: item.account_code,
                            account_name: item.account_description,
                        };
                        
                        // Procesar cada elemento del cuerpoDocumento
                        for (const element of item.cuerpoDocumento) {
                            
                            // Normalizar el nombre del servicio eliminando espacios
                            const normalizedServiceName = (element.descripcion || '').trim();
                            const normalizedCode = element.codigo ? element.codigo.trim() : element.codigo;
                            
                            // Verificar si el servicio existe
                            let existingService = await this.checkServiceExists(normalizedServiceName, normalizedCode);
                            let serviceId = null;
                            
                            if (!existingService) {
                                // Crear el servicio si no existe
                                try {
                                    // Crear con nombre normalizado
                                    const normalizedElement = {
                                        ...element,
                                        descripcion: normalizedServiceName,
                                        codigo: normalizedCode
                                    };
                                    existingService = await this.createService(normalizedElement);
                                } catch (error) {
                                    console.error('Error creating service:', error);
                                    // Continuar sin servicio si hay error
                                }
                            }
                            
                            serviceId = existingService ? existingService.CodeService : null;
                            
                            const serviceExists = existingService && (existingService.exists === true || !existingService.created);

                            const service = {
                                ...headerExpense,
                                descripcion: normalizedServiceName, // Usar el nombre normalizado
                                codigo: normalizedCode || null,
                                precioUni: element.precioUni,
                                cantidad: element.cantidad,
                                montoDescu: element.montoDescu,
                                ventaNoSuj: element.ventaNoSuj,
                                ventaExenta: element.ventaExenta,
                                ventaGravada: element.ventaGravada,
                                ItemDeclarationType: 2,
                                id_service: serviceId,
                                service_exists: serviceExists,
                                service_status: serviceExists ? 'Existe' : 'Creado'
                            };
                            
                            if(service.ventaNoSuj != 0 && service.ventaExenta == 0 && service.ventaGravada == 0) service.total = service.ventaNoSuj;
                            else if(service.ventaNoSuj == 0 && service.ventaExenta != 0 && service.ventaGravada == 0) service.total = service.ventaExenta;
                            else service.total = service.ventaGravada;

                            services.push(service);
                        }
                    }
                }
            }
            this.expensesData = services; // Mantener el nombre de la variable para compatibilidad con la UI
            this.loading = false;
        },
        readFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => resolve(event.target.result);
                reader.onerror = (error) => reject(error);
                reader.readAsText(file);
            });
        },
        async checkCustomer(dte) {
            try {
                const item = dte.receptor;
                const tipoDte = dte.identificacion.tipoDte;
                const cliente = (dte?.receptor?.nombre || '').toLowerCase();
                const clientesVarios = ['cliente', 'clientes', 'clientes varios', 'varios', 'cliente vario'].some(c => cliente.includes(c));
                
                let searchParams = [];
                const pushUnique = (type, value) => {
                    if (!value) return;
                    if (!searchParams.some(p => p.searchType === type && p.searchValue === value)) {
                        searchParams.push({ searchType: type, searchValue: value });
                    }
                };

                if (cliente) {
                   pushUnique('name', cliente.trim()) 
                }

                if (tipoDte === "01" && clientesVarios) {
                    pushUnique('cv', '1');
                }

                if (item.tipoDocumento && item.numDocumento && ["01", "11"].includes(tipoDte)) {
                    if (item.tipoDocumento === '36') {
                        pushUnique('nit', item.numDocumento);
                    } else if (item.tipoDocumento === '13') {
                        pushUnique('dui', item.numDocumento);
                    }
                }

                if (["03", "05"].includes(tipoDte)) {
                    if (item.nrc) {
                        pushUnique('nrc', item.nrc);
                    } else if (item.nit) {
                        pushUnique('nit', item.nit);
                    }
                }

                if (item.correo) {
                    pushUnique('email', item.correo);
                }
                
                if (searchParams.length == 0) {
                    return null;
                }
                
                const response = await this.$API.customers.findCustomerByDocument({searchParams});
                //console.log({checkCustomer:response});
                // El backend devuelve { success: true, data: [customer] } o { success: false, message: "Customer not found" }
                if (response.success && response.data && response.data.length > 0) {
                    return response.data[0][0];
                }
                return null;
            } catch (error) {
                return null;
            }
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            const newDate = new Date(`${month}/${day}/${year}`)
            return this.moment(newDate).format('DD/MM/YYYY');
        },
        getNombre(nombre) {
            if (!nombre) {
                return { firstname: '', lastname: '' };
            }

            const parts = nombre.trim().split(/\s+/);

            let firstname = '';
            let lastname = '';

            if (parts.length === 1) {
                firstname = parts[0];
            } else if (parts.length === 2) {
                firstname = parts[0];
                lastname = parts[1];
            } else if (parts.length === 3) {
                firstname = parts.slice(0, 2).join(' ');
                lastname = parts[2];
            } else {
                firstname = parts.slice(0, 2).join(' ');
                lastname = parts.slice(2).join(' ');
            }

            return { firstname, lastname };
        },
        async addCustomer(data) {
            const dte = data.dte
            const receptor = dte.receptor
            const tipoDte = dte.identificacion?.tipoDte;
            let customerNIT = receptor.nit ? receptor.nit.toString().replaceAll("-","") : null;
            let customerDUI = null;
            let customerNRC = receptor.nrc ? receptor.nrc.toString().replaceAll("-","") : null;
            if (!["03", "05"].includes(tipoDte) && receptor.numDocumento && receptor.tipoDocumento) {
                const numDocumento = receptor.numDocumento.toString().replaceAll("-","")
                if(receptor.tipoDocumento == "36"  && numDocumento.length == 14)
                {
                    customerNIT = numDocumento;
                }else if (["36", "13", "37", "03", "02"].includes(receptor.tipoDocumento) && numDocumento.length != 14) {
                    customerDUI = numDocumento;
                }
            }
            const isBusiness = (receptor.codActividad && receptor.codActividad.length > 0) || (customerNIT && customerNIT.trim());
            
            const email = (receptor.correo || '').toString().trim().toLowerCase();
            const telefono =  (receptor.telefono || '').toString().trim().replaceAll("-","")
            const { firstname, lastname } = this.getNombre(receptor.nombre);
            // Usar las claves en minúscula como espera el backend
            const customer = {
                firstname: !isBusiness ? firstname : null,
                lastname: !isBusiness ? lastname : null,
                legalname: receptor.nombre || receptor.nombreComercial,
                businessname: isBusiness? receptor.nombreComercial : null,
                phonenumber: !isBusiness ? telefono : null,
                businessphone: isBusiness ? telefono : null,
                email: !isBusiness ? email : null,
                BusinessEmail: isBusiness ? email : null,
                address: receptor.direccion ? receptor.direccion.complemento : null,
                legalsector: receptor.codActividad,
                legaltaxpayersize: "",
                legalentity: isBusiness? "PERSONA JURÍDICA":"PERSONA NATURAL",
                descActividad: receptor.descActividad,
                legalnrc: customerNRC,
                legalnit: customerNIT,
                dui: customerDUI,
                notes: 'Insertado automáticamente por importación de ventas',
                idbusiness: this.id_bussiness,
                idbranch: this.id_branch,
                iduserinsert: this.id_user,
                legalagentretain: dte.ivaPerci1 > 0 ? 1 : 0,
                isBusiness: isBusiness,                    // Si tiene NIT es negocio
                isOng: false,
                isPublicEntity: false,               // Si no tiene NIT es entidad pública
                islegal: false,
                Department: receptor.departamento,

            };
            
            // Encapsular en customerData como espera el backend
            const customerData = {
                customerData: customer
            };

            return await this.$API.customers.addCustomer(customerData)
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.log(error)
                    throw new Error('Ha ocurrido un error al insertar el cliente, intentelo de nuevo más tarde.');
                });
        },
        async checkDuplicatedEntries(value) {
            return await this.$API.invoices.checkDuplicatedInvoices(value)
                .then((response) => {
                    return response;
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        async checkServiceExists(serviceName, alternateCode = null) {
            try {
                // Normalizar los parámetros de entrada
                const normalizedServiceName = (serviceName || '').trim();
                const normalizedAlternateCode = alternateCode ? alternateCode.trim() : null;
                
                // Si tiene código alterno, usar el endpoint específico para buscar por código
                if (normalizedAlternateCode && normalizedAlternateCode !== '') {
                    const response = await this.$API.services.findServiceByAlternateCode(normalizedAlternateCode);
                    
                    if (response.success && response.data) {
                        return response.data;
                    }
                }
                
                // Si no tiene código alterno o no se encontró, buscar por nombre usando searchServicesOpc
                const response = await this.$API.services.searchServicesOpc(normalizedServiceName);
                
                if (response.success && response.data && response.data.length > 0) {
                    // Buscar coincidencia exacta por nombre usando las propiedades correctas y normalizando espacios
                    const exactMatch = response.data.find(service => {
                        const labelMatch = (service.label || '').trim() === normalizedServiceName;
                        const valueMatch = (service.value || '').trim() === normalizedServiceName;
                        const nameMatch = (service.name || '').trim() === normalizedServiceName;
                        
                        return labelMatch || valueMatch || nameMatch;
                    });
                    
                    if (exactMatch) {
                        // Retornar el servicio encontrado con toda la información
                        return {
                            id_service: exactMatch.ID_Service || exactMatch.id_service,
                            ID_Service: exactMatch.ID_Service || exactMatch.id_service,
                            CodeService: exactMatch.CodeService || exactMatch.CodeService,
                            name: exactMatch.name || exactMatch.label,
                            label: exactMatch.label,
                            value: exactMatch.value,
                            exists: true // Marcador de que el servicio ya existe
                        };
                    }
                }
                
                return null;
            } catch (error) {
                console.log('Error checking service:', error);
                return null;
            }
        },
        async createService(serviceData) {
            try {
                // Usar el nuevo método que llama al stored procedure sp_InsertInventoryService
                const serviceParams = {
                    serviceName: serviceData.descripcion,
                    category: 'OTR', // Categoría por defecto
                    unitPrice: serviceData.precioUni || 0,
                    business: this.id_bussiness,
                    branch: this.id_branch,
                    alternateCode: serviceData.codigo || ''
                };

                const response = await this.$API.services.insertInventoryService(serviceParams);
                
                if (response.success && response.data) {
                    return { 
                        ...response.data, 
                        created: true,
                        id_service: response.data.ID_Service || response.data.id_service
                    };
                }
                return null;
            } catch (error) {
                console.log('Error creating service with SP:', error);
                throw new Error('No se pudo crear el servicio: ' + serviceData.descripcion);
            }
        },
        getAllAccounts() {
            this.$API.branchaccountcatalog.getAssignableAccounts()
                .then((response) => {
                    this.accountList = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        handleChangeAccount(e, index) {
            const found = this.accountList.find((current) => current.id_account == e.target.value);        
            this.expensesData[ index ].id_account = found.id_account;
            this.expensesData[ index ].account_code = found.account_code;
            this.expensesData[ index ].account_name = found.account_description;
            this.data[ index ].id_account = found.id_account;
            this.data[ index ].account_code = found.account_code;
            this.data[ index ].account_name = found.account_description;
            this.handleBlurOnSelect();
        },
        handleBlurOnSelect() {
            this.isSelectShowed = false;
        },
        toggleSelect(index) {
            this.isSelectShowed = true;
            // Enfocar el select cuando se abre
            if (this.$nextTick) {
                this.$nextTick(() => {
                    const accountListSelect = `accountListSelect-${index}`;
                    if (this.$refs[accountListSelect]) {
                        this.$refs[accountListSelect].focus();
                    }
                });
            }
        },
        assignAllAccounts() {       
            const found = this.accountList.find((current) => current.id_account == this.account.id_account);        
            for (const item of this.expensesData) {
                if (found) {
                    /* item.id_account = found.id_account;
                    item.account_code = found.account_code;
                    item.account_name = found.account_description; */
                    this.$set(item, 'id_account', found.id_account);
                    this.$set(item, 'account_code', found.account_code);
                    this.$set(item, 'account_name', found.account_description);
                } 
            }
            for (const item of this.data) {
                if (found) {
                    item.id_account = found.id_account;
                    item.account_code = found.account_code;
                    item.account_name = found.account_description;
                    /* this.$set(item, 'id_account', found.id_account);
                    this.$set(item, 'account_code', found.account_code);
                    this.$set(item, 'account_name', found.account_description); */
                } 
            }
            this.$forceUpdate();            
            this.showAlert("success", "Exito", `Se ha actualizado la tabla asignando la cuenta seleccionada a los gastos importados.`);
        },
        async processData() {
            this.loading = true;
            this.nextStep();
            try {
                if(!this.expensesData.length || !this.data.length) throw new Error('No ha seleccionado archivo con la información.');
                                 
                for (const item of this.data) {
                    const formData = new FormData();
                    const invoiceDetails = [];

                    if(item.toEntry === true && !item.error?.customerError) {
                        
                        // Detectar si es la nueva versión
                        const isNewVersionDCL = this.isNewVersionJson(item.dteJson);
                        
                        let invoiceData;
                        
                        if (isNewVersionDCL) {
                            // Nueva versión - generar factura de servicios
                            invoiceData = {
                                ID_Customer: item.customer,
                                InvoiceDate: item.fecEmi,
                                InvoiceType: item.invoiceType,
                                InvoiceStatus: 'Pendiente de pago',
                                InvoiceStatusDescription: item.dteJson.resumen?.condicionOperacion === 2 ? 'Crédito' : 'Cancelada',
                                SubTotal: item.dteJson.cuerpoDocumento.subTotal || 0,
                                TotalInvoice: item.dteJson.cuerpoDocumento.liquidoApagar || 0,
                                InvoiceComment: 'Factura generada por importación automática',
                                Iva: item.dteJson.cuerpoDocumento.iva || 0,
                                IvaPerc: item.dteJson.cuerpoDocumento.ivaPercibido || 0,
                                InvoiceName: item.dteJson.receptor.nombre,
                                InvoiceAddress: item.dteJson.receptor.direccion ? item.dteJson.receptor.direccion.complemento : null,
                                InvoiceNRC: item.dteJson.receptor.nrc,
                                InvoiceNIT: item.dteJson.receptor.nit,
                                InvoiceDUI: (item.dteJson.receptor.tipoDocumento === '13') ? item.dteJson.receptor.documento : null,
                                InvoicePaymentType: this.getPaymentTypeDescription(item.dteJson.resumen?.pagos?.[0]?.codigo),
                                DteJson: item.dteJson,
                                numeroControl: item.dteJson.identificacion.numeroControl,
                                codigoGeneracion: item.codigoGeneracion,
                                isDuplicated: item.error?.isDuplicated ? true : false,
                                id_business: this.id_bussiness,
                                id_branch: this.id_branch,
                                id_user: this.id_user,
                                fecha_id_invoice: this.FechaIdInvoice,
                            };
                            
                            // Buscar servicios relacionados con esta factura
                            const relatedServices = this.expensesData.filter(service => 
                                service.codigoGeneracion === item.codigoGeneracion
                            );
                            
                            // Crear detalles de servicios
                            for (const service of relatedServices) {
                                if (service.id_service) {
                                    const serviceDetail = {
                                        ID_Service: service.id_service,
                                        ServiceName: service.descripcion,
                                        UnitPrice: service.precioUni,
                                        Quantity: service.cantidad,
                                        Total: service.total,
                                        IsExento: service.ventaExenta > 0 ? 1 : 0,
                                        IsNoSujeto: service.ventaNoSuj > 0 ? 1 : 0,
                                        ID_Account: service.id_account
                                    };
                                    invoiceDetails.push(serviceDetail);
                                }
                            }
                            
                        } else {
                            // Versión tradicional - generar factura de servicios
                            invoiceData = {
                                ID_Customer: item.customer,
                                InvoiceDate: item.fecEmi,
                                InvoiceType: item.invoiceType,
                                InvoiceStatus: this.invoiceStatus[item.dteJson.resumen?.condicionOperacion] || 'Pendiente de pago',
                                InvoiceStatusDescription: item.dteJson.resumen?.condicionOperacion === 2 ? 'Crédito' : 'Cancelada',
                                SubTotal: item.subTotal,
                                TotalInvoice: item.totalPagar,
                                InvoiceComment: 'Factura generada por importación automática',
                                Iva: item.iva || 0,
                                IvaPerc: item.dteJson.resumen?.ivaPerci1 || 0,
                                InvoiceName: item.dteJson.receptor.nombre,
                                InvoiceAddress: item.dteJson.receptor.direccion ? item.dteJson.receptor.direccion.complemento : null,
                                InvoiceNRC: item.dteJson.receptor.nrc,
                                InvoiceNIT: item.dteJson.receptor.nit,
                                InvoiceDUI: (item.dteJson.receptor.tipoDocumento === '13') ? item.dteJson.receptor.documento : null,
                                InvoicePaymentType: this.getPaymentTypeDescription(item.dteJson.resumen?.pagos?.[0]?.codigo),
                                DteJson: item.dteJson,
                                numeroControl: item.numeroControl,
                                codigoGeneracion: item.codigoGeneracion,
                                isDuplicated: item.error?.isDuplicated ? true : false,
                                id_business: this.id_bussiness,
                                id_branch: this.id_branch,
                                id_user: this.id_user, 
                                fecha_id_invoice: this.FechaIdInvoice,
                            };

                            // Buscar servicios relacionados con esta factura
                            const relatedServices = this.expensesData.filter(service => 
                                service.codigoGeneracion === item.codigoGeneracion
                            );
                            
                            // Crear detalles de servicios
                            for (const service of relatedServices) {
                                if (service.id_service) {
                                    const serviceDetail = {
                                        ID_Service: service.id_service,
                                        ServiceName: service.descripcion,
                                        UnitPrice: service.precioUni,
                                        Quantity: service.cantidad,
                                        Total: service.total,
                                        IsExento: service.ventaExenta > 0 ? 1 : 0,
                                        IsNoSujeto: service.ventaNoSuj > 0 ? 1 : 0,
                                        ID_Account: service.id_account
                                    };
                                    invoiceDetails.push(serviceDetail);
                                }
                            }
                        }                        
                        
                        // Solo procesar si hay servicios válidos
                        if (invoiceDetails.length > 0) {
                            formData.append("invoiceData", JSON.stringify(invoiceData));
                            formData.append("invoiceDetails", JSON.stringify(invoiceDetails));
                            
                            // Usar endpoint para generar facturas de servicios
                            await this.$API.invoices.createServiceInvoice(formData)
                                .then((res) => {
                                    if(res.success) {
                                        this.processed.push(item);
                                    }
                                })
                                .catch((error) => {
                                    this.notProcessed.push(item);
                                    console.log('Error creating service invoice:', error);
                                });
                        } else {
                            // No hay servicios válidos para esta factura
                            this.notProcessed.push({
                                ...item,
                                error: {
                                    message: 'No se pudieron crear o encontrar servicios válidos para esta factura'
                                }
                            });
                        }                
                    }
                    else {
                        this.notProcessed.push(item);
                    }
                }
                this.loading = false;
                if(this.data.length == this.processed.length) {
                    this.showAlert("success", "Facturas de servicios generadas", "Las facturas de servicios fueron generadas correctamente.");
                }
                else if(this.data.length == this.notProcessed.length) {
                    this.showAlert("warning", "Facturas de servicios", "Las facturas de servicios no pudieron procesarse debido a la existencia de errores.");
                }
                else if(this.data.length != this.processed.length) {
                    this.showAlert("warning", "Facturas de servicios", "Algunas facturas de servicios no pudieron procesarse debido a la existencia de errores.");
                }
            } 
            catch (error) {
                this.loading = false;
                this.processError = true;
                this.showAlert("danger", "Error", error.message || "Ocurrio un error en el procesamiento de la información.");
            }
        },
        exportToExcel(value) {
            if(value === 'ERROR') {
                const headers = this.tableHeaders.map(header => header.text);
                const data = this.productsNotAllowed.map(item => this.tableHeaders.map(header => item[header.value]));
    
                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Plantilla inventario');
    
                XLSX.writeFile(workbook, 'plantilla_inventario_errores.xlsx');

            } else if(value === 'SUCCESS') {
                const headers = this.expensesHeaders.map(header => header.text);
                const data = this.processed.map(item => this.expensesHeaders.map(header => item[header.value]));
    
                const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Gastos importados');
    
                XLSX.writeFile(workbook, 'Gastos_importados.xlsx');

            }
        },
        switchEntryData(item) {
            if(!item) return;
            
            for (const element of this.dataFiles) {
                if(element.identificacion.numeroControl == item.numeroControl && element.identificacion.codigoGeneracion == item.codigoGeneracion) {
                    element.toEntry = !element.toEntry;
                }
            }
        },
        switchSelectAll() {
            for (const item of this.data) {
                    item.toEntry = this.selectAll;
                }
            for (const item of this.dataFiles) {
                item.toEntry = this.selectAll;
            }
        },
        deleteFile(file) {
            console.log(file);
            this.data.filter((item) => item.numeroControl != file.numeroControl && item.codigoGeneracion != file.codigoGeneracion);
            this.dataFiles.filter((item) => item.identificacion.numeroControl != file.numeroControl && item.identificacion.codigoGeneracion != file.codigoGeneracion);
        },
        onClickProcess() {
            this.showAlert("question2", "Advertencia", "¿Esta seguro que desea continuar?", "processData");
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        closeAlert() {
            this.alert.show = false;
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
        },
        acceptAlert() {
            this.alert.show = false;
            if (this.alert.options == 'processData') {
                this.processData();
            }
            if (this.alert.options == 'continueStep') {
                this.nextStep();
            }
            if (this.alert.options == 'structureValidation') {
                this.structureValidation();
            }
            if (this.alert.options == 'handleFilesUpload') {
                this.handleFilesUpload();
            }
        },
        showError(message) {
            this.showAlert("warning", "Advertencia", message);
        },
        resetData() {
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.expensesData = [];
            this.errors = null;
            this.processError = false;
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
        },
        resetAll() {
            this.step = 1;
            this.loading = false;
            this.dataLoaded = false;
            this.selectAll = true;
            this.selectedFiles = [];
            this.selectedFilesNames = [];
            this.dataFiles = [];
            this.data = [];
            this.expensesData = [];
            this.errors = null;
            this.processError = false;
            this.processed = [];
            this.notProcessed = [];
            this.showNotProcessed = false;
            this.showProcessed = false;
            this.account = {
                id_account: null
            };
            this.percentageIvaCheck = true;
            this.percentageIva = 100;
            this.cleanState = true;
        },
        getPaymentTypeDescription(codigo) {
            const paymentTypes = {
                '01': 'Billetes y monedas',
                '02': 'Tarjeta Débito',
                '03': 'Tarjeta Crédito', 
                '04': 'Cheque',
                '05': 'Transferencia-Depósito Bancario',
                '08': 'Dinero electrónico',
                '09': 'Monedero electrónico',
                '11': 'Bitcoin',
                '12': 'Otras Criptomonedas',
                '13': 'Cuentas por pagar del receptor',
                '14': 'Giro bancario',
                '99': 'Otros (se debe indicar el medio de pago)'
            };
            return paymentTypes[codigo] || 'Billetes y monedas';
        },
    }
};
</script>

<style scoped>
.card-step {
    min-height: 400px; 
    width: 100%; 
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 2rem;
}
.col-input-file {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 1rem;
}
.btn-import {
  background-color: #3498db !important;
  color: white;
  min-width: 250px !important;
  height: 40px !important;
}
.btnoption {
  background-color: #3498DB !important;
  color: white;
}
.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}
.btndisable {
    background-color: #41464c !important;
    color: white;
}
</style>

<style>
.mdi-file-excel::before {
    font-size: 32px !important;
}
.data-table .v-data-table__wrapper thead th {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.data-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
}
.file-table .v-data-table__wrapper thead th {
    height: 5px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody tr {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td.text-start {
    padding: 0px;
    border: 0px !important;
}
.file-table .v-data-table__wrapper tbody td {
    height: 35px !important;
    text-wrap: nowrap;
    min-width: 100px;
    border: 0px !important;
}
.tabs-seg .v-slide-group__content {
    justify-content: space-between;
}
.check .v-input__control {
    flex-direction: row !important;
    flex-wrap: nowrap !important;
}

</style>
